import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import { isWeb } from 'utils/responsiveness';

export const MAX_MENU_WIDTH = 260;
export const MARGIN_TOP = 60;
export const MORE_LEFT_POSITION = 20;
export const MARGIN_RIGHT = isWeb ? 112 : 44;
export const SVG_HALF_WIDTH = 8;

const styles = StyleSheet.create({
    modal: { margin: 0 },
    container: {
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        width: MAX_MENU_WIDTH,
        borderRadius: 8,
    },
    blockArrow: {
        position: 'absolute',
        top: -18,
        width: 24,
        height: 24,
        borderColor: COLOR.COD_GRAY_LIGHT,
        borderTopWidth: 1,
        borderRightWidth: 1,
        transform: [
            { rotate: '-44deg' },
            { translateX: -6 },
            { translateY: 6 },
        ],
        backgroundColor: COLOR.COD_GRAY_LIGHT,
    },
});

export default styles;
